import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {CustomOrderReturnComponent} from './custom-order-return.component';
import {CmsConfig, ConfigModule, I18nModule, UrlModule} from "@spartacus/core";
import {ReactiveFormsModule} from "@angular/forms";
import {FormErrorsModule} from "@spartacus/storefront";
import {NgSelectModule} from "@ng-select/ng-select";
import {RouterModule} from "@angular/router";
import {CustomIconsModule} from "../../../icons/custom-icons.module";
import {CustomFileUploaderModule} from "../../../forms/file-uploader/custom-file-uploader.module";
import {CustomInfoboxformModule} from "../../content/custom-infoboxform/custom-infoboxform.module";
import { RecaptchaModule } from '../../../../spartacus/features/recaptcha/recaptcha.module';


@NgModule({
  declarations: [CustomOrderReturnComponent],
  imports: [
    CommonModule,
    ConfigModule.withConfig({
      cmsComponents: {
        OrderReturnsFormComponent: {
          component: CustomOrderReturnComponent,
        },
      },
    } as CmsConfig),
    I18nModule,
    ReactiveFormsModule,
    FormErrorsModule,
    NgSelectModule,
    RouterModule,
    CustomIconsModule,
    UrlModule,
    CustomFileUploaderModule,
    CustomInfoboxformModule,
    RecaptchaModule,
  ],
})
export class CustomOrderReturnModule { }
